<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<n-data-table
    #dt
    (onRowExpand)="onRowExpand($event)"
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="useData"
    [loading]="loading"
    id="lun-mapping-table">
    <n-table-expand *ngIf="type == 'host' || type == 'hostGroup'">
        <ng-template
            let-columns
            let-data="rowData"
            let-index="rowIndex"
            nTemplate>
            <!-- 映射对象为LUN组展示下拉表格 -->
            <app-mapping-member-lun
                (searchChange)="saveFilterParams($event)"
                [data]="data"
                [filterParams]="filterParamsMap[data.lunGroupId]"
                (setRouter)="jumpToPath($event)">
            </app-mapping-member-lun>
        </ng-template>
        <ng-template let-data="rowData" let-index="rowIndex" nTemplate="column">
            <svg
                (click)="onClickExpand(data, index)"
                *ngIf="data && data.lunGroupId !== ''"
                [class.active]="expandMap[data.lunGroupId]"
                class="n-table-expand-cell-icon icon-style">
                <use xlink:href="#core-icon-arrow-bold-right"></use>
            </svg>
        </ng-template>
    </n-table-expand>
</n-data-table>

<ng-template #lunLinkTemp let-data="rowData">
    <app-mapping-lun-link [data]="data" (clickItem)="jumpToPath($event)"></app-mapping-lun-link>
</ng-template>
